// frontend/src/admin/RichTextEditor.js
import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
    ClassicEditor,
    Essentials,
    Paragraph,
    Bold,
    Italic,
    Underline,
    FontSize,
    FontColor,
    FontBackgroundColor,
    List
} from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';

/**
 * Shared rich text editor wrapper (CKEditor 5, modular install, free GPL license).
 * Usage: <RichTextEditor value={htmlString} onChange={(html) => setState(html)} />
 * Stores/returns HTML string — plug this in place of any <textarea> that needs
 * bold/italic/underline/font-size/lists formatting.
 */
const RichTextEditor = ({ value, onChange, placeholder }) => {
    return (
        <div className="ace-richtext-wrapper">
            <CKEditor
                editor={ClassicEditor}
                data={value || ''}
                config={{
                    licenseKey: 'GPL',
                    placeholder: placeholder || '',
                    plugins: [Essentials, Paragraph, Bold, Italic, Underline, FontSize, FontColor, FontBackgroundColor, List],
                    toolbar: [
                        'bold', 'italic', 'underline', '|',
                        'fontSize', 'fontColor', 'fontBackgroundColor', '|',
                        'bulletedList', 'numberedList', '|',
                        'undo', 'redo'
                    ],
                    fontSize: {
                        options: [10, 12, 'default', 16, 18, 22, 26, 32]
                    }
                }}
                onChange={(event, editor) => {
                    const data = editor.getData();
                    onChange(data);
                }}
            />
        </div>
    );
};

export default RichTextEditor;